export default __webpack_public_path__ + "c8c0e5dcbfb124e34b7302aabcea7798.png";